import React from "react";

export class CustomTitle extends React.Component {
  render() {
    return (
      <div className="custom-title text-center my-4 mt-5">
        <div className="d-flex align-items-center justify-content-center">
          {this.props.icon && this.props.icon_type === "img" && (
            <img
              src="/assets/images/ri_auction-fill.png"
              height="34"
              alt="Title Icon"
              className="me-2"
            />
          )}

          {this.props.icon && this.props.icon_type === "icon" && (
            <i className={`${this.props.icon} me-2 title-icon`}></i>
          )}

          <h2 className="title-text mb-0">{this.props.title} {this.props.count ? <span
            className="badge ms-2"
            style={{
              backgroundColor: 'rgba(92,92,92,1)',
              fontSize: "1.3rem",
            }}
          >{this.props.count}</span> : ""}</h2>
        </div>
      </div>
    );
  }
}
